import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import Button from 'flarum/common/components/Button';
import EventAssignModal from './components/EventAssignModal';
import { hasEventsTag } from './utils/eventsTag';
export default function addEventControl() {
  // Mirrors champis-species' addSpeciesControl.js - a button in the
  // discussion's controls dropdown. Shown only when the discussion has the
  // events tag AND the actor is allowed to touch its event data (its
  // author, or anyone with the `discussion.rename` permission - computed
  // server-side as canEditEvent, see extend.php).
  extend(DiscussionControls, 'userControls', function (items, discussion) {
    if (!app.session.user) return;
    if (!hasEventsTag(discussion.tags ? discussion.tags() : [])) return;
    if (!discussion.canEditEvent()) return;
    items.add('event', m(Button, {
      icon: "fas fa-calendar-alt",
      onclick: () => app.modal.show(EventAssignModal, {
        discussion,
        onsubmit: event => discussion.save({
          event
        })
      })
    }, app.translator.trans('champis-events.forum.event.control_button')));
  });
}